import * as React from 'react';
import {useState, useEffect} from 'react';
import {view, tokens} from '@sail/ui';
import {createKeyframes} from '@sail/engine';
import {defineMessages, useIntl} from 'react-intl';

const shimmer = createKeyframes({
  0: {backgroundPosition: '200% center'},
  100: {backgroundPosition: '-200% center'},
});

const messages = defineMessages({
  analyzing_request: {
    id: 'conversations_ui.loading_text.analyzing_request',
    description: 'The first loading text that shows',
    defaultMessage: 'Analyzing request',
  },
  in_progress: {
    id: 'conversations_ui.loading_text.in_progress',
    description:
      'The second loading text that shows when the first one is done',
    defaultMessage: 'In progress',
  },
  generating_response: {
    id: 'conversations_ui.loading_text.generating_response',
    description:
      'The third loading text that shows when the second one is done',
    defaultMessage: 'Generating response',
  },
});

export function LoadingText() {
  const intl = useIntl();
  const [dots, setDots] = useState('');
  const [content, setContent] = useState(
    intl.formatMessage(messages.analyzing_request),
  );
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      if (dots.length === 3) {
        setDots('');
      } else {
        setDots((prev) => `${prev}.`);
      }
    }, 750);

    return () => clearInterval(interval);
  });

  useEffect(() => {
    const updateContent = (newContent: string) => {
      setOpacity(0);
      setTimeout(() => {
        setContent(newContent);
        setOpacity(1);
      }, 300);
    };

    const timeout1 = setTimeout(() => {
      updateContent(intl.formatMessage(messages.in_progress));
      setDots('');
    }, 3000);

    const timeout2 = setTimeout(() => {
      updateContent(intl.formatMessage(messages.generating_response));
      setDots('');
    }, 9000);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [intl]);

  return (
    <view.div>
      <view.span
        css={{
          animation: `${shimmer} 4.5s linear infinite`,
          fontSize: 'label.medium',
          background: `linear-gradient(90deg, ${tokens.color.neutral[300].toString()}, ${tokens.color.neutral[500].toString()}, ${tokens.color.text.subdued.toString()}, ${tokens.color.text.$default.toString()}, ${tokens.color.neutral[300].toString()})`,
          backgroundSize: '200% auto',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          color: 'transparent',
          opacity,
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        {content}
        {dots}
      </view.span>
    </view.div>
  );
}
